import { BreakPointCondition, SliderModal, useBreakpointIf } from '@genial/components';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import React from 'react';

import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../../routes/types';

import { TermHistoryContent } from './components/TermHistoryContent';

export const FixedFeeTermHistoryModal: React.FC = () => {
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'FixedFeeTermHistoryModal'>>();
  const { goBack, canGoBack, navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const handleClose = () => {
    if (canGoBack()) {
      return goBack();
    }

    navigate('FixedFee', undefined);
  };

  return (
    <SliderModal onDismiss={handleClose} width={isTablet ? 1 : 0.4}>
      <TermHistoryContent {...params} onClose={handleClose} />
    </SliderModal>
  );
};
